import React, { Fragment } from 'react';
// child components
import DriverMapComponent from '../../components/driver-map/driver-map.component';
import DriverInfoComponent from '../../components/driver-info/driver-info.component';
// import HighlightInfoComponent from '../../components/highlight-info/highlight-info.component';
// product service
import BookingProductService from '../../services/booking-product.service';
// models
import IDriverTrackingStatus from '../../models/driver-tracking-status.interface';
import ILocation from '../../models/location.interface';
import ITimeslot from '../../models/timeslot.interface';
// styles
const styles = require('./driver-status.scss');

declare var exponea: any;
interface IState {
  driverData: IDriverTrackingStatus;
  locationData: ILocation;
  timeslotData: ITimeslot;
  locationType: string;
  loaded: boolean;
}

interface IProps {
  trackingData: any;
  queryParams: any;
  language: string;
  multiLang: any;
  airlineCode: string;
  airlineName: string;
}

class DriverStatusComponent extends React.Component<IProps, IState> {

  // private product = null;
  public bookingProductService = null;

  constructor(props: any) {
    super(props);
    this.state = {
      driverData: props.trackingData.driverTrackingStatus,
      timeslotData: props.trackingData.collectionSlot !== null ? props.trackingData.collectionSlot : props.trackingData.deliverySlot,
      locationData: props.trackingData.collectionLocation !== null ? props.trackingData.collectionLocation : props.trackingData.deliveryLocation,
      locationType: props.trackingData.collectionLocation !== null ? 'collection' : 'delivery',
      loaded: false
    };
  }

  componentDidMount() {
    this.bookingProductService = new BookingProductService(this.props.trackingData.trackingBookingDetails, this.props.trackingData.collectionSlot);
    // this.product = this.bookingProductService.returnProductDetails();
    this.setState({ loaded: true });
    exponea.track('tracking_screen', { 'page_name': 'DriverTrack', 'product_type': 'abc' });
  }

  componentWillReceiveProps(props: IProps) {
    if (props.trackingData !== null && props.trackingData.driverTrackingStatus) {
      this.setState({ driverData: props.trackingData.driverTrackingStatus });
      this.setState({ locationData: props.trackingData.collectionLocation !== null ? props.trackingData.collectionLocation : props.trackingData.deliveryLocation });
    }
  }

  public render() {
    const { driverData, locationData, timeslotData, locationType } = this.state;
    const { trackingData, queryParams, language, multiLang } = this.props;
    const { completedTrackingStatus } = trackingData;

    return (
      <Fragment>
        <div className={styles.mainContent}>
          <div className={styles.sectionWrapper}>
            <div className={styles.section}>
              <div className={styles.card}>
                <div className={styles.cardBody}>

                  <h1 className={styles.heading}>
                    {multiLang[`yourDriverIsOnTheWayText${language}`]}
                  </h1>

                  <div className={styles.sectionMapWrapper}>

                    <DriverMapComponent
                      language={language}
                      multiLang={multiLang}
                      driverData={driverData}
                      locationType={locationType}
                      locationData={locationData}></DriverMapComponent>

                  </div>

                  <div>
                    <DriverInfoComponent
                      language={language}
                      multiLang={multiLang}
                      driverData={driverData}
                      locationData={locationData}
                      timeslotData={timeslotData}
                      locationType={locationType}
                      queryParams={queryParams}
                      airlineCode={this.props.airlineCode}
                      airlineName={this.props.airlineName}
                      bagsJourney={trackingData.bagsJourney}
                      completedTrackingStatus={completedTrackingStatus}
                      pnrBookingData={trackingData.pnrBookingData}>
                    </DriverInfoComponent>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }

}

export default DriverStatusComponent;



// WEBPACK FOOTER //
// ./src/containers/driver/driver-status.component.tsx